import React from 'react';
import { Navigate } from 'react-router-dom'; // From React Router
import { useIsAuthenticated } from '@azure/msal-react';

const ProtectedRoute = ({ children }) => {
  //const isAuthenticated = useIsAuthenticated();
  const isAuthenticated = true;
  if (!(isAuthenticated)) {
    // Redirect to sign-in page or render a sign-in component
    return <Navigate to="/signin" />;
  }

  return children;
};

export default ProtectedRoute;
